import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import axiosInstance from 'src/utils/axios';

const useIsDuplicateApIdApi = (poId: string) => {
  const execute = useCallback(
    (apId: string) =>
      new Promise<boolean>((resolve, reject) => {
        axiosInstance
          .get<boolean>(api.isDuplicateApId(poId), { params: { apId } })
          .then((data) => {
            resolve(data.data);
          })
          .catch((reason) => {
            reject(reason.error);
          });
      }),
    [poId]
  );

  return { execute };
};

export default useIsDuplicateApIdApi;
